import {BsModalRef} from 'ngx-bootstrap/modal/bs-modal-ref.service';
import {Component, Injector} from '@angular/core';
import {Subject} from 'rxjs/Subject';
import {BsModalService} from 'ngx-bootstrap/modal';
import {ModalBaseComponent} from '../modal-base-component';
import {CARDGROUPINFO} from "../../../../gen/swagger-api";

@Component({
  selector: 'app-table-header-search-modal',
  templateUrl: './table-header-search-modal.component.html',
  styleUrls: ['./table-header-search-modal.component.css']
})
export class TableHeaderSearchModalComponent extends ModalBaseComponent {
  propertyName: string;
  enums: Array<String>;
  pools: any;
  cardGroups: Array<CARDGROUPINFO>;
  searchText: String;
  paginationIndex: number = 1;
  flags: boolean;
  flagTextDelete: String = 'Select';
  flagTextFallback: String = 'Select';
  deleteBootstrap: boolean;
  fallback: boolean;

  public filterParams: Subject<any>;
  public selectedCardGroupIds;
  public selectedPoolIds;
  public selectedStatus;
  private bsModalRef: BsModalRef;

  constructor(inject: Injector, private _bsModalRef: BsModalRef,
              private modalService: BsModalService) {
    super(inject);
    this.enums = ['SUCCESS', 'WARNING', 'FAILED', 'EXPIRED', 'IN_PROCESS', 'CANCELED'];

    this.filterParams = new Subject<any>();

  }

  public closeModal(): void {
    this._bsModalRef.hide();
    this.filterParams.next({
      selectedCardGroupIds: this.selectedCardGroupIds,
      selectedPoolIds: this.selectedPoolIds,
      selectedStatus: this.selectedStatus,
      deleteBootstrap: this.deleteBootstrap,
      fallback: this.fallback
    });
  }

  public onToggleSelectedCardGroupId(event) {
    this.processElementSelection(event, this.selectedCardGroupIds);
  }

  public onToggleSelectedPoolId(event) {
    this.processElementSelection(event, this.selectedPoolIds);
  }

  public onToggleSelectedStatus(event) {
    this.processElementSelection(event, this.selectedStatus);
  }

  private processElementSelection(event, array) {
    const id = event.target.value;
    if (array.includes(id)) {
      const index = array.findIndex(d => d === id); // find index in your array
      array.splice(index, 1); // remove element from array
    } else {
      array.push(id);
    }
  }

  public setDeleteBootstrap(value: boolean) {
    this.deleteBootstrap = value;
    this.flagTextDelete = value.toString();
  }

  public setFallback(value: boolean) {
    this.fallback = value;
    this.flagTextFallback = value.toString();
  }
}



// WEBPACK FOOTER //
// ./src/app/achelos-iot/modals/table-header-search-modal/table-header-search-modal.component.ts